import { Component, ViewChild, OnInit } from '@angular/core';
import { NgModel, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';

import 'rxjs';
export interface Item { name: string; rate: number;}
import * as _ from 'lodash';
import * as moment from 'moment';
import * as firebase from 'firebase/app';

import {MatAccordion} from '@angular/material/expansion';

@Component({
  selector: 'app-billentry',
  templateUrl: './billentry.component.html',
  styleUrls: ['./billentry.component.css']
})
export class BillentryComponent implements OnInit {
  @ViewChild(MatAccordion, {static: false}) accordion: MatAccordion;

  date2= moment().format('DD-MM-YYYY');
  showMainContent: Boolean = true;
  menucollection: any = [];
  itemcollection: any = [];
  billitemcollection: any = [];
  billsubscribecollection: any = [];
  selectedMenu: any= null;
  selectedItem: any;
  selectedTable: any= "Table 1";
  tables: any;
  
  //qntycounters
qntycounters: { tid: string, itemid: string, qntycount: number }[]= [] //declare before constructor
//qntycounters
tablecurrentcounter: any ="2";
  kgspcs: { tid: string, kgs:number, pcs:number }[]= [];
  totkgs: number;
  totpcs:number;

addorreplace(array, item){
  const i=array.findIndex(_item => _item.tid===item.tid && _item.itemid===item.itemid);
  if(i>-1) array[i] =item;
  else array.push(item);
 }



bufferValue=0;
  value=0; //progressbar
  favoriteCustomer: string;
  customers: string[] = ['regular', 'seasonal', 'festival'];
  billoc: string;
  billocations: string[] = ['shop1', 'shop2', 'shop3'];
  cbilly: string;
  iscbill: string[] = ['yes', 'no'];
 
 taxy:string;
 taxes = [{label:'gst',checked:true}, {label:'igst',checked:false}, {label:'taxfree',checked:false}];
 
   TaxnameGST: string='gst';
   TaxnameIGST: string='0';
   TaxnameTF: string='0';

 tottaxableamt: number;
 totamtwithtax: number;

 sumaftrdisc:number;

 totalamount: number;
 totalrate: number;

 summy: { tid: string, gst: number, rate: number, taxableamt: number, amtaftdisc:number }[]= [];
 hello: string;
 custid: any;
 custname: any;
 custaddress11: any;
 custaddress12: any;
 custaddress21: any;
 custaddress22: any;
 custcontact: any;
 custgst: any;
 custhonor: any;
 custaddressS1: any;
 custaddressS2: any;
 sameaddr: boolean;
 prdkeyid: any;
 bcbtndisabled: boolean;
 clrbtndisabled: boolean;
 addbtndisabled: boolean;

 billqnty: any;
 prdqnty: any;
 rembtndisabled: boolean;

 arry:{
   code:string;
   qnty:number;
 }[]=[];

 prdkeyidarray:string[]=[];
 billqntyarray:number[]=[];

 totbills:number;
 crcollection: any;


 allroutineidarry: { id: number, location: string, status: string }[]=[];
 completedroutineidarry: { id: number, location: string, status: string }[]=[];
 uncompletedroutineidarry: { id: number, location: string, status: string }[]=[];
     eventdate: string;
     crd: number=0;
     dbt: number=0;


     billid : any;
     billrefno : any;

     currentbillid:any;

 updateCheckedOptions(index, tax) {
  console.log("updateCheckedOptions called")
  
  if(this.taxy=='gst'){this.TaxnameGST='gst';this.TaxnameIGST='0';this.TaxnameTF='0';}
  if(this.taxy=='igst'){this.TaxnameIGST='igst';this.TaxnameGST='0';this.TaxnameTF='0';}
  if(this.taxy=='taxfree'){this.TaxnameTF='taxfree';this.TaxnameGST='0';this.TaxnameIGST='0';}



   if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
   this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
       this.billrefno="A"+doc.data().countG;
   })
   if(this.taxy.toUpperCase().slice(0, 1)=="T")
   this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
       this.billrefno="B"+doc.data().countR;
   })
}


  constructor(private afs: AngularFirestore) {
   
    this.favoriteCustomer=this.customers[0]; // set default radio button checked
    this.billoc=this.billocations[0]; // set default radio button checked
    this.taxy='gst' // set default radio button checked
    this.cbilly='no' // set default radio button checked
    this.billitemcollection='';
    this.billsubscribecollection='';



    this.tables = [
      { id: 91, name: "TAKE AWAY 1" },
      { id: 92, name: "TAKE AWAY 2" },
      { id: 1, name: "TABLE 1" },
      { id: 2, name: "TABLE 2" },
      { id: 3, name: "TABLE 3" },
      { id: 4, name: "TABLE 4" },
      { id: 5, name: "TABLE 5" },
      { id: 6, name: "TABLE 6" },
      { id: 7, name: "TABLE 7" },
      { id: 8, name: "TABLE 8" },
      { id: 9, name: "TABLE 9" },
      { id: 10, name: "TABLE 10" },
      { id: 100, name: "ORDER" },
    ];

    this.menucollection =   this.afs.collection('Mastermenu').snapshotChanges()      
    .pipe( 
      map(actions => actions.map(a => a.payload.doc.data()))
    );

    this.selectedtablechange("TABLE 1");
    }

  ngAfterViewInit() {
    var el =document.getElementsByClassName('rightsidebar') as HTMLCollectionOf<HTMLElement>;
    el[0].style.cssText="max-width: 800px !IMPORTANT; width: 800px !IMPORTANT;"
    //console.log("ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ")
    this.eventdate=moment().format('DD-MM-YYYY')

}

    async ngOnInit() {

      //newly added
      this.summy=[];
      this.tottaxableamt=0;
      this.sumaftrdisc=0;
      this.totamtwithtax=0;
      this.kgspcs=[];
      this.totkgs=0;
      this.totpcs=0;
      //newly added

if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
  this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
      this.billrefno="A"+doc.data().countG;
  })
  if(this.taxy.toUpperCase().slice(0, 1)=="T")
  this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
      this.billrefno="B"+doc.data().countR;
  })


let document = await firebase.firestore().collection("Bills").doc(this.date2).get();
if (document && document.exists) {
  // await document.ref.update({
  //   updated: new Date().toISOString()
  // });
}
else {
  await document.ref.set({
    currbillid : 1,
    currbillfullid : this.billoc.toUpperCase().slice(0,1)+this.billoc.toUpperCase().slice(-1)+this.favoriteCustomer.toUpperCase().slice(0,1)+this.taxy.toUpperCase().slice(0,1)+'1',
    totalbills : 0,
    date2 : this.date2,
  }, { merge: true });
  
}

this.crcollection = this.afs.collection('Bills', ref => ref.where('date2', '==', this.date2)).snapshotChanges()
.pipe( 
  map(actions => actions.map(a => a.payload.doc.data()))
);

this.crcollection.subscribe(() => {
  this.afs.collection('Bills', ref => ref.where('date2', '==', this.date2)).get().toPromise().then(querySnapshot => {
    querySnapshot.forEach(docy => {
      this.currentbillid = docy.data().currbillid;
    })
  })

  //newly added
  if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
    this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
        this.billrefno="A"+doc.data().countG;
    })
    if(this.taxy.toUpperCase().slice(0, 1)=="T")
    this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
        this.billrefno="B"+doc.data().countR;
    })
  //newly added
  })



this.afs.collection('Bills', ref => ref.where('date2', '==', this.date2)).get().toPromise().then(querySnapshot => {
  querySnapshot.forEach(docy => {
    this.currentbillid = docy.data().currbillid;
  })
}).then(()=>{
//newly added
if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
    this.billrefno="A"+doc.data().countG;
})
if(this.taxy.toUpperCase().slice(0, 1)=="T")
this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
    this.billrefno="B"+doc.data().countR;
})
//newly added
  })
.then(()=>{

  this.afs.collection('Bills').doc(this.date2).collection('--DUMMIES--').doc(String(this.currentbillid)).set(
    {
      currentbillid: this.currentbillid,
      currbillfullid: this.billoc.toUpperCase().slice(0, 1) + this.billoc.toUpperCase().slice(-1) + this.favoriteCustomer.toUpperCase().slice(0, 1) + this.taxy.toUpperCase().slice(0, 1) + this.currentbillid,
      location: this.billoc,
      status:'created'
    },
     { merge: true }
  )
  //console.log("aaaaaaaa");

})

}


updateradiobuttons(){
  this.afs.collection('Bills', ref => ref.where('date2', '==' , this.date2)).get().toPromise().then(querySnapshot => {
    querySnapshot.forEach(docy => {
this.currentbillid=docy.data().currbillid;
  this.afs.collection('Bills').doc(this.date2).collection('--DUMMIES--').doc(String(this.currentbillid)).update({
    currentbillid: this.currentbillid,
    currbillfullid: this.billoc.toUpperCase().slice(0,1)+this.billoc.toUpperCase().slice(-1)+this.favoriteCustomer.toUpperCase().slice(0,1)+this.taxy.toUpperCase().slice(0,1)+docy.data().currbillid,
  })
})
  })
  //newly added
if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
    this.billrefno="A"+doc.data().countG;
})
if(this.taxy.toUpperCase().slice(0, 1)=="T")
this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
    this.billrefno="B"+doc.data().countR;
})
//newly added
}

updateBillCheckedOptions(i, billocation)
{
  this.updateradiobuttons();
}
updateCustCheckedOptions(i, customer)
{
  this.updateradiobuttons();
}



loaditem(){
  this.itemcollection =   this.afs.collection('Items', ref => ref.where('mastermenu', '==', this.selectedMenu)).snapshotChanges()      
  .pipe( 
    map(actions => actions.map(a => a.payload.doc.data()))
  );
}

upcount(itmid: any,itname: any, qnty: any){
  this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).get().toPromise().then(querySnapshot => {

      querySnapshot.forEach(doc => {
        if (doc.data().itemid == itmid) {
          if(!this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid)){
            //qntycounters insert
            this.addorreplace(this.qntycounters,{'tid': this.selectedTable,'itemid':itmid, qntycount: qnty + doc.data().unit1});
            //console.log(JSON.stringify(this.qntycounters));
            //qntycounters insert
              }
            else {
            //qntycounters update
            this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount = this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount + doc.data().unit1;
            //console.log(JSON.stringify(this.qntycounters));
            //qntycounters update
            }

  this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).doc(itmid).set(
    {
      qnty : this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount, //qnty
      rate : ((this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount) * (doc.data().rate / doc.data().qnty)),
      amountafterdiscount:((this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount) * (doc.data().amountafterdiscount / doc.data().qnty)),
    },
     {merge: true}
).then(()=>{
  
})
  .catch((err) => {
    //console.log(err);
  })
        }
      })
      
    }).then(()=>{
  
    })
      .catch((err) => {
        //console.log(err);
      })
  
}

downcount(itmid: any,itname: any, qnty: any){
  this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).get().toPromise().then(querySnapshot => {

      querySnapshot.forEach(doc => {
        if (doc.data().itemid == itmid) {
          if(!this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid)){
            //qntycounters insert
            this.addorreplace(this.qntycounters,{'tid': this.selectedTable,'itemid':itmid, qntycount: qnty - doc.data().unit1});
            //console.log(JSON.stringify(this.qntycounters));
            //qntycounters insert
              }
            else {
            //qntycounters update
            this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount = this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount - doc.data().unit1;
            //console.log(JSON.stringify(this.qntycounters));
            //qntycounters update
            }

  this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).doc(itmid).set(
    {
      qnty : this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount, //qnty
      rate : ((this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount) * (doc.data().rate / doc.data().qnty)),
      amountafterdiscount:((this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount) * (doc.data().amountafterdiscount / doc.data().qnty)),
    },
     {merge: true}
).then(()=>{
  
})
  .catch((err) => {
    //console.log(err);
  })
        }
      })
      
    }).then(()=>{
  
    })
      .catch((err) => {
        //console.log(err);
      })
  
}
removebillitem(itmid,itname){
  this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).doc(itmid).delete()
  this.qntycounters=this.qntycounters.filter(item=>item.tid!=this.selectedTable.toString());

}

 ShowHideButton() {
  this.showMainContent = this.showMainContent ? false : true;     
}

callbeforeselectedtablechange(){  
  // console.log("FROM:"+this.selectedTable);
  this.afs.collection('Tables').doc(this.selectedTable.toString()).update(
    {
      discount: this.favoriteCustomer,
      taxtype: this.taxy
    }
  )
  // console.log(this.taxy);
}
   selectedtablechange(tb: any){

    this.selectedTable=tb;

     this.tablestatus(tb);
   }

   tablestatus(tb){
    this.afs.collection('Tables').doc(this.selectedTable).get().toPromise().then(doc=>{
    this.favoriteCustomer=doc.data().discount; 
    //this.billoc=doc.data().billocation;
    this.taxy=doc.data().taxtype; 
    this.cbilly='no';
    }).then(()=>{

     // console.log("TO:"+this.selectedTable);
     // console.log(this.taxy);

   if(this.taxy=='gst'){this.TaxnameGST='gst';this.TaxnameIGST='0';this.TaxnameTF='0';}
   if(this.taxy=='igst'){this.TaxnameIGST='igst';this.TaxnameGST='0';this.TaxnameTF='0';}
   if(this.taxy=='taxfree'){this.TaxnameTF='taxfree';this.TaxnameGST='0';this.TaxnameIGST='0';}
   
   if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
   this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
       this.billrefno="A"+doc.data().countG;
   })
   if(this.taxy.toUpperCase().slice(0, 1)=="T")
   this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
       this.billrefno="B"+doc.data().countR;
   })

      this.loadbill(tb);

    })
   }
   
   menuclicked(mn: any) {
    this.selectedMenu = mn;
    this.loaditem();
    this.ShowHideButton();
  }

  itemclicked(itname: any, itmid: any) {

    this.selectedItem = itname;
    //console.log(itname, itmid);

    this.loadbillbasiccontent(itname, itmid);
    //this.ShowHideButton();

  }

loadbill(tbname: any){
  //console.log(tbname);
  this.afs.collection('Tables').doc(tbname).get().toPromise().then(  doc => {
    this.tablecurrentcounter=doc.data().counter.toString();
}).then(()=>{
this.billitemcollection = this.afs.collection('Tables').doc(tbname).collection(this.tablecurrentcounter).snapshotChanges()
.pipe( 
  map(actions => actions.map(a => a.payload.doc.data()))
);
//console.log(this.billitemcollection);
})
.then(()=>{
  this.billsubscribe();
})
}

   loadbillbasiccontent(itname,itmid){

    //console.log("tablecurrentcounter>>>"+ this.tablecurrentcounter);

    this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).get().toPromise().then(sub=>{
if(sub.docs.length>0)
{
  console.log("exists");

  sub.forEach(docy => {
    if (docy.data().itemid == itmid) {
    this.addorreplace(this.qntycounters,{'tid': this.selectedTable,'itemid':docy.data().itemid, qntycount: docy.data().qnty});
    console.log(JSON.stringify(this.qntycounters));
    }
  })

        this.afs.collection('Items', ref => ref.where('itemid', '==', itmid)).get().toPromise().then(querySnapshot => {
          querySnapshot.forEach(doc => {

           if(!this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid)){
              console.log("exists if called")//existed table existed item fresh click

              
    this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).doc(itmid).set(
      {
                   itemid: doc.data().itemid,
                itemname: doc.data().itemname,
                mastermenu: doc.data().mastermenu,
                rate : doc.data().rate,
                qnty : doc.data().unit1,

                unit1: doc.data().unit1,
                unit2: doc.data().unit2,

                cgst: doc.data().gst/2,
                igst: doc.data().igst,
                amountafterdiscount: (doc.data().rate - (doc.data().rate * ((doc.data().discount[this.favoriteCustomer])/100))),
                status: "ordered"
                },
              { merge: true }
            )
               //qntycounters insert
          this.addorreplace(this.qntycounters,{'tid': this.selectedTable,'itemid':itmid, qntycount: doc.data().unit1});
          console.log(JSON.stringify(this.qntycounters));
          //qntycounters insert
              }
            
            else{
              console.log("exists else called")//existed table existed item second and after click
              
              //qntycounters update
              this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount = this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount + doc.data().unit1;
              console.log(JSON.stringify(this.qntycounters));
              //qntycounters update
  
              sub.forEach(docy => {
                if (docy.data().itemid == itmid) {
                  console.log("ify called");
            this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).doc(itmid).set(
              {
              qnty : this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount, //qnty
      rate : (((this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount)) * (docy.data().rate / docy.data().qnty)),
      amountafterdiscount:((this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid).qntycount) * (docy.data().amountafterdiscount / docy.data().qnty)),
            },
            { merge: true }
          )
                }
          })

            }



      })
    })
      
}
else{
  console.log("!exists"); //empty table

        this.afs.collection('Items', ref => ref.where('itemid', '==', itmid)).get().toPromise().then(querySnapshot => {
          querySnapshot.forEach(doc => {

            if(!this.qntycounters.find(item => item.tid == this.selectedTable && item.itemid == itmid)){
              console.log("!exists if called") //fresh table fresh item fresh click

              this.afs.collection('Tables').doc(this.selectedTable).collection(this.tablecurrentcounter.toString()).doc(itmid).set(
                {
                  itemid: doc.data().itemid,
                  itemname: doc.data().itemname,
                  mastermenu: doc.data().mastermenu,
                  rate: doc.data().rate,
                  qnty: doc.data().unit1,
                  unit1: doc.data().unit1,
                  unit2: doc.data().unit2,
  
                  cgst: doc.data().gst/2,
                  igst: doc.data().igst,
                  amountafterdiscount: (doc.data().rate - (doc.data().rate * ((doc.data().discount[this.favoriteCustomer])/100))),
                  status: "ordered"
                },
                { merge: true }
              )
              

          //qntycounters insert
          this.addorreplace(this.qntycounters,{'tid': this.selectedTable,'itemid':itmid, qntycount: doc.data().unit1});
          console.log(JSON.stringify(this.qntycounters));
          //qntycounters insert

            }

            
            else{
              console.log("!exists else called") //not possible

            }
      })
    })




}
    })
    .then(()=>{
      this.billsubscribe();
    })

    .catch(function(error) {
      //console.log("Error getting document:", error);
  });
   }


   billsubscribe(){  

    // this.billsubscribecollection = this.afs.collection('Tables', ref => ref.where('tableid', '==', this.selectedTable.toString())).snapshotChanges()
    // .pipe( 
    //   map(actions => actions.map(a => a.payload.doc.data()))
    // );
    this.billitemcollection = this.afs.collection('Tables').doc(this.selectedTable.toString()).collection(this.tablecurrentcounter).snapshotChanges()
    .pipe( 
      map(actions => actions.map(a => a.payload.doc.data()))
    );

    this.billitemcollection.subscribe((posts) => {
    

//newly added
      this.kgspcs=_(posts).groupBy('unit2')
    .map((objs, key) => {

        return {
      'unit2': key,
      'kgs':(key == "KG(S)") ? _.sumBy(objs, 'qnty') : 0,
      'pcs':(key == "PC(S)") ? _.sumBy(objs, 'qnty') : 0,
        }
    })
    .value();
    this.totkgs=this.kgspcs.reduce((sum, item) => sum + item.kgs, 0)
    this.totpcs=this.kgspcs.reduce((sum, item) => sum + item.pcs, 0)
    //console.log("this.totkgs"+this.totkgs)
    //console.log("this.totpcs"+this.totpcs)
//newly added



      //console.log("posty:"+posts); //This is the array of posts, not an observable
    
      if(this.TaxnameGST != '0'){
      this.summy=_(posts).groupBy('cgst')
        .map((objs, key) => {
            return {
                'cgst': key,
                // 'rate': _.sumBy(objs, 'rate') * _.maxBy(objs, 'qnty'),
          'amtaftdisc': (_.sumBy(objs, 'amountafterdiscount')),
          'gstp':(key*2),
          'cgstp':(parseFloat(key)),
          'cgsta':((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
          'sgstp':(parseFloat(key)),
          'sgsta':((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
          'igstp':(parseFloat('0')),
          'igsta':(parseFloat('0.00')),
          'taxableamt':2 * ((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
            }
        })
        .value();
    
        this.tottaxableamt=this.summy.reduce((sum, item) => sum + item.taxableamt, 0)
        this.totamtwithtax=this.summy.reduce((sum, item) => sum + item.amtaftdisc, 0) + this.tottaxableamt;
    
        this.sumaftrdisc=this.summy.reduce((sum, item) => sum + item.amtaftdisc, 0);

        //console.log("SUMMYYY:"+JSON.stringify(this.summy));
        //console.log("tottaxableamt:"+this.tottaxableamt);
        //console.log("totamtwithtax:"+this.totamtwithtax);
        //console.log("sumaftrdisc:"+this.sumaftrdisc);
      }
    
      if(this.TaxnameIGST != '0'){
        this.summy=_(posts).groupBy('igst')
          .map((objs, key) => {
              return {
                  'igst': key,
                  // 'rate': _.sumBy(objs, 'rate') * _.maxBy(objs, 'qnty'),
                  
                  'amtaftdisc': (_.sumBy(objs, 'amountafterdiscount')),
                  'gstp':(0),
                  'cgstp':(parseFloat('0')),
                  'cgsta':(parseFloat('0.00')),
                  'sgstp':(parseFloat('0')),
                  'sgsta':(parseFloat('0.00')),
                  'igstp':(parseFloat(key)),
                  'igsta':((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
                  'taxableamt':((parseFloat(key)) * (_.sumBy(objs, 'amountafterdiscount'))/100),
                   }
          })
          .value();
    
          this.tottaxableamt=this.summy.reduce((sum, item) => sum + item.taxableamt, 0)
          this.totamtwithtax=this.summy.reduce((sum, item) => sum + item.amtaftdisc, 0) + this.tottaxableamt;
    
    this.sumaftrdisc=this.summy.reduce((sum, item) => sum + item.amtaftdisc, 0);
    
          //console.log("SUMMYYY:"+JSON.stringify(this.summy));
        }
    
    
        if(this.TaxnameTF != '0'){
          this.summy=_(posts).groupBy('taxfree')
            .map((objs, key) => {
                return {
                    'taxfree': key,
                    // 'rate': _.sumBy(objs, 'rate') * _.maxBy(objs, 'qnty'),
                    
                    'amtaftdisc': (_.sumBy(objs, 'amountafterdiscount')),
                    'gstp':(0),
                    'cgstp':(parseFloat('0')),
                    'cgsta':(parseFloat('0.00')),
                    'sgstp':(parseFloat('0')),
                    'sgsta':(parseFloat('0.00')),
                    'igstp':(parseFloat('0.00')),
                    'igsta':(parseFloat('0.00')),
                    'taxableamt':(parseFloat('0.00')),
                     }
            })
            .value();
    
            this.tottaxableamt=this.summy.reduce((sum, item) => sum + item.taxableamt, 0)
            this.totamtwithtax=this.summy.reduce((sum, item) => sum + item.amtaftdisc, 0) + this.tottaxableamt;
    
            this.sumaftrdisc=this.summy.reduce((sum, item) => sum + item.amtaftdisc, 0)
    
            //console.log("SUMMYYY:"+JSON.stringify(this.summy));
          }
    
    
      //console.log("posts:"+posts); //This is the array of posts, not an observable
    
      let ratetotal = 0;
      let amounttotal = 0;
    //console.log("zzzzzzzzzzzzzzzzzzzzzzzzzz:"+posts.length);
    for (var i = 0; i < posts.length; i++) {
        if (posts[i].rate) {
          //console.log("zzzzzzzzzzzzzzzzzzzzzzzzzz:"+posts[i].rate);
            ratetotal += posts[i].rate;
            this.totalrate = ratetotal;
    
            // amounttotal += (posts[i].rate * posts[i].qnty);
            amounttotal += (posts[i].rate);
            this.totalamount = amounttotal;
        }
    }
    //console.log("zzzzzzzzzzzzzzzzzzzzzzzzzz:"+ratetotal);
    return [ratetotal,amounttotal];
    
    });   
    
   }



  async submitbtn(){

    //----copy collection------
//     let srcCollection = await this.afs.collection('Tables').doc('TABLE 1').collection('1');
//     let destCollection = this.afs.collection('Bills').doc('20-04-2021').collection('4');
  
//     srcCollection.get().toPromise().then(query => {
//   query.forEach(function(doc) {
//     destCollection.doc(doc.data().itemid).set(doc.data());
//   });
// });
   //----copy collection------




    //------newly added------
//this.btnsdisabled();
//------newly added------

  this.hello=document.getElementById('billidlabel').textContent;

      let srcCollection = await this.afs.collection('Tables').doc(this.selectedTable.toString()).collection(this.tablecurrentcounter.toString());
    let destCollection = this.afs.collection('Bills').doc(this.date2).collection(String(this.currentbillid));
  
    srcCollection.get().toPromise().then(query => {
  query.forEach(function(doc) {
    destCollection.doc(doc.data().itemid).set(doc.data());
    // destCollection.doc(doc.data().itemid).update({
    //   amountafterdiscount: (2 * doc.data().qnty)
    // });
  });
});





  this.afs.collection('Bills', ref => ref.where('date2', '==', this.date2)).get().toPromise().then(querySnapshot => {
    querySnapshot.forEach(docy => {
this.totbills=docy.data().totalbills;
  this.afs.collection('Bills').doc(this.date2).set(
    {
      totalbills : this.totbills + 1,
      currbillid : this.currentbillid + 1,
      billsid:firebase.firestore.FieldValue.arrayUnion(this.hello),
      billsrefno:firebase.firestore.FieldValue.arrayUnion(this.billrefno)
    },
    {merge: true}
 )

  })
  
})

.then(() => {
  
  if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I"){
    this.afs.collection('OverallBillCounter').doc('Counter').set(
      {
        countG : firebase.firestore.FieldValue.increment(1),
      },
       {merge: true}
  )

    }
    if(this.taxy.toUpperCase().slice(0, 1)=="T"){
      this.afs.collection('OverallBillCounter').doc('Counter').set(
        {
          countR : firebase.firestore.FieldValue.increment(1),
        },
         {merge: true}
    )
      }
      
  })
  .then(()=>{
//newly added
if(this.taxy.toUpperCase().slice(0, 1)=="G" || this.taxy.toUpperCase().slice(0, 1)=="I")
this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
    this.billrefno="A"+doc.data().countG;
})
if(this.taxy.toUpperCase().slice(0, 1)=="T")
this.afs.collection('OverallBillCounter').doc('Counter').get().toPromise().then(  doc => {
    this.billrefno="B"+doc.data().countR;
})
//newly added
}).then(()=>{
  
  this.afs.collection('Bills').doc(this.date2).collection('--Id--').doc(String(this.currentbillid)).set(
    {
      currentbillid: this.currentbillid,
      currbillfullid: this.billoc.toUpperCase().slice(0, 1) + this.billoc.toUpperCase().slice(-1) + this.favoriteCustomer.toUpperCase().slice(0, 1) + this.taxy.toUpperCase().slice(0, 1) + this.currentbillid,
      location: this.billoc,
      status:'completed'
    },
     { merge: true }
  )
  //console.log("aaaaaaaa");

  this.afs.collection('Bills').doc(this.date2).collection('--DUMMIES--').doc(String(this.currentbillid)).set(
    {
      currentbillid: this.currentbillid,
      currbillfullid: this.billoc.toUpperCase().slice(0, 1) + this.billoc.toUpperCase().slice(-1) + this.favoriteCustomer.toUpperCase().slice(0, 1) + this.taxy.toUpperCase().slice(0, 1) + this.currentbillid,
      status:'completed'
    },
     { merge: true }
  )

})


.then(() => {
  this.afs.collection('Bills').doc(this.date2).collection('--stats--').doc(String(this.currentbillid)).set(
    {
      // billid: this.currentbillid,
      // taxtype : this.taxy,
      // location: this.billoc,
      // customertype: this.favoriteCustomer
    },
     {merge: true}
  )
})

.then(() => {
  this.afs.collection('Tables').doc(this.selectedTable.toString()).set(
    {
      counter : firebase.firestore.FieldValue.increment(1),
    },
     {merge: true}
  )
})


.then(() => {
  this.tablecurrentcounter= (Number(this.tablecurrentcounter)+1).toString();

  //console.log(this.selectedTable.toString()+"HHHHH"+this.tablecurrentcounter);

  //newly added
  this.ngOnInit();
  this.qntycounters=this.qntycounters.filter(item=>item.tid!=this.selectedTable.toString());
})
  //newly added
  .then(()=>{
    this.billitemcollection = this.afs.collection('Tables').doc(this.selectedTable.toString()).collection(this.tablecurrentcounter).snapshotChanges()
    .pipe( 
      map(actions => actions.map(a => a.payload.doc.data()))
    );
    //console.log(this.billitemcollection);
    })



}

}
